// extracted by mini-css-extract-plugin
export default {"container":"LargeLoader_container__5AXQS","spinner":"LargeLoader_spinner__QMCsG","spinner-c7wet2":"LargeLoader_spinner-c7wet2__1w5tR"};